import LandingFixedButton from "@/components/common/LandingFixedButton";
import { useViewpostTopObserver } from "@/hooks/useViewpostTopObserver";
import { Stack } from "@chakra-ui/react";
import { colors, responsive, VStack } from "goi_common";

import GuideContent from "./components/Guide/GuideContent";

import GuideHead from "./components/Guide/GuideHead";
import GuideSummary from "./components/Guide/GuideSummary";

export default function Feed100SangjoContainer({ href }: { href?: string }) {
  const { viewportTopRef } = useViewpostTopObserver();
  const feed = {
    path: "about-promise",
    date: "25-04-09",
    title: "투명하고 정직한 장례를 위한 고이의 약속",
    description: "",
    imgSrc: "direct/content/sn/2-1.png",
    keyword: "상조, 장례, 100원 상조",
    summary: {
      title: "아래에 해당하시면 도움 될 거예요 (2분)",
      description: [
        "👨🏻‍🦱: 대부분의 상조는 어떻게 운영될까?",
        "👩🏻: 고이는 어떤 약속을 하려는걸까?",
      ],
    },
    contents: [
      {
        type: "p",
        resource: " ",
      },
      {
        type: "h2",
        resource: "상조 서비스만 가입하면 장례식 비용 준비 끝일까?",
      },
      {
        type: "h3",
        resource: "대부분의 상조 회사는요.",
      },
      {
        type: "p",
        resource:
          "고객 유치에만 집중하고 실제 장례 서비스 운영은 하청업계에 맡겨요. 장례식을 직접 도와주는 장례지도사는 하청업체와 연결된 개인사업자고요.",
      },
      {
        type: "p",
        resource:
          "장례지도사의 역할은 1. 장례식 진행과 2. 이에 필요한 수의, 관, 꽃, 장의차량 등 각종 용품 조달인데요. 고객에게 비싸고 좋은 용품을 팔수록 보수가 커져요. 현장에서 용품을 판매할 때 일부를 수당 형식으로 받거든요.",
      },
      {
        type: "p",
        resource:
          "반면 고객이 가입한 기본 상조 상품으로만 장례를 치르면 이득을 남기기 힘들어요. 몇몇 상조 회사는 추가 판매를 하지 못하는 장례지도사에게 불이익을 줘 문제가 되기도 했어요.",
      },
      {
        type: "img",
        resource: "direct/content/sn/2-2.png",
        imgAlt: "가전제품과 상조",
      },
      {
        type: "h3",
        resource: "상조 시장을 고쳐나가려는 고이의 노력",
      },
      {
        type: "p",
        resource: "",
      },
      {
        type: "p",
        resource: "<b>고이는 이런 상조의 부조리한 구조를 개선하려고 해요.</b>",
      },
      {
        type: "p",
        resource:
          "고이는 장례용품 조달을 IT로 효율화했어요. 고객 맞춤으로 장례용품이 추천되고 바로 예약할 수 있으니 장례지도사는 일명 ‘끼워팔기’를 할 수도, 할 필요도 없어요. 대신 하청업체 없이 장례지도사와 1 대 1로 직접 계약해 안정적인 보수를 제공해요.",
      },
      {
        type: "p",
        resource:
          "이런 수익 구조를 기반으로 고이는 추가 금액 유도 없는 합리적인 서비스를 제공해요. 가족 분들의 장례가 상술로 얼룩진 기억이 아닌 합리적이고 따뜻한 기억이 될 수 있도록 3가지 약속을 지키고 있어요.",
      },
      {
        type: "p",
        resource: "<b>1. 업계 최초 품목별 가격 정찰제</b>",
      },
      {
        type: "p",
        resource:
          "무엇이 얼마인지, 그 비용을 투명하게 공개하는 것은 당연한 일이에요. 불필요한 혜택이나 상품 없이 꼭 필요한 것만 모아 비용을 낮추고, 업계 최초로 모든 품목에 가격 정찰제를 도입하여 실제로 사용한 품목만 비용을 받아요.",
      },
      {
        type: "p",
        resource: "<b>2. 사용하지 않은 품목 100% 현금 공제</b>",
      },
      {
        type: "p",
        resource:
          "사용하지 않은 품목이 있을 때, 그 비용을 지불하지 않는 것은 당연한 일이죠. ‘권리 포기로 간주', ‘다른 품목으로 대체 제공'과 같은 관행을 거부하고 패키지 내 사용하지 않은 품목에 대해 명시된 금액만큼 100% 현금으로 공제해요.",
      },
      {
        type: "p",
        resource: "<b>3. 서비스 불만족시 100% 환불 정책</b>",
      },
      {
        type: "p",
        resource:
          "고객님께서 수고비를 주시지 않는 것은 당연한 일이에요. 감사한 마음은 따뜻한 말 한마디와 정성스러운 후기로 대신 받겠습니다. 좋은 서비스는 계약에 이미 포함되어 있는 것으로서 장례 용품 강매, 노잣돈 및 수고비 강요 등의 부적절한 행위를 엄격히 금지하고 있어요.",
      },
    ],
  };
  return (
    <VStack width="100%" alignItems="center">
      <div ref={viewportTopRef}></div>
      <GuideHead title={feed.title} date={""} imgSrc={feed.imgSrc} isFeed />
      <Stack
        maxWidth={`720px`}
        width="100%"
        css={responsive({
          gap: { base: "28px", md: "40px" },
          padding: { base: "0 0 160px", lg: "60px 0px 160px" },
        })}
      >
        {feed.summary && <GuideSummary summary={feed.summary} />}
        <GuideContent contents={feed.contents} isFeed />
      </Stack>
      <LandingFixedButton
        color={colors.brown650}
        text="고이 프라임으로 장례 준비하기"
        href={href || "/#about-promise"}
        eventPath="feed"
      />
    </VStack>
  );
}
